import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-amaal-planner',
  imports: [PagePlaceholderComponent],
  templateUrl: './amaal-planner.component.html',
  styleUrl: './amaal-planner.component.scss'
})
export class AmaalPlannerComponent {
  protected readonly icon = '📅';
  protected readonly pageTitle = 'pages.amaal_planner.title';
  protected readonly subtitle = 'pages.amaal_planner.subtitle';
}
